import { countryConfig, provinceConfig } from './cantonConfig';
import { commonMenu } from './commonMenu';

const authProvider = process.env.REACT_APP_AUTH_PROVIDER || 'legacy';
const allowKeycloakAuthEnv = process.env.REACT_APP_ALLOW_KEYCLOAK_AUTH;
const allowLoginPasswordAuthEnv =
    process.env.REACT_APP_ALLOW_LOGIN_PASSWORD_AUTH;

function fromEnvBoolean(value, fallback) {
    if (value === undefined) {
        return fallback;
    }

    return value !== 'false';
}

const config = {
    authProvider,
    allowKeycloakAuth: fromEnvBoolean(
        allowKeycloakAuthEnv,
        authProvider === 'keycloak'
    ),
    allowLoginPasswordAuth: fromEnvBoolean(
        allowLoginPasswordAuthEnv,
        authProvider !== 'keycloak'
    ),
    language: 'en',
    languages: ['en', 'de', 'fr', 'it'],
    provinces: provinceConfig,
    countries: countryConfig,
    defaultSort: {
        field: 'id',
        direction: null
    },
    systemRoles: ['ecoo', 'partner', 'merchant', 'user'],
    allowMerchantRegistration: true,
    allowGoogleAuth: true,
    allowTwoFactorAuth: ['ecoo', 'partner'],
    chartSettings: {
        hiddenFields: []
    },
    hiddenColumns: null, // { nameTable: ['idColumn'] }
    menu: commonMenu
};

export default config;
